// extracted by mini-css-extract-plugin
export default {"MarketplaceContainer":"marketplace-container_MarketplaceContainer__3PKbB typography_bodyFont__1UNdB"};